/**
 * @generated SignedSource<<f701f9acdc77fdc9a8eff0da9cecc150>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersCheckIfNewsSectionInFirstIndexSection$data = {
  readonly name: string;
  readonly " $fragmentType": "helpersCheckIfNewsSectionInFirstIndexSection";
};
export type helpersCheckIfNewsSectionInFirstIndexSection$key = {
  readonly " $data"?: helpersCheckIfNewsSectionInFirstIndexSection$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckIfNewsSectionInFirstIndexSection">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersCheckIfNewsSectionInFirstIndexSection"
};

(node as any).hash = "6e8f2841292d960663692ee075e0d780";

export default node;
